import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { TabBar, TabsMaster, SearchAdminProgramRequests } from '../../../components';

export const ProgramRequestAdminPage = props => {
    const [tabs, setTabs] = useState([
        { id: 'submitted', label: 'Submitted', count: '' },
        { id: 'review', label: 'Under Review', count: '' },
        { id: 'approved', label: 'Approved', count: '' },
        { id: 'denied', label: 'Denied', count: '' },
        { id: 'deleted', label: 'Deleted', count: '' },
    ]);
    const dataStorage = window.sessionStorage.getItem('programRequestTabData')
        ? JSON.parse(window.sessionStorage.getItem('programRequestTabData'))
        : null;
    const [tabData, setTabData] = useState(dataStorage ? dataStorage : []);
    const [activeTab, setActiveTab] = useState('submitted');

    useEffect(() => {
        return () => {
            window.sessionStorage.setItem(
                'programRequestTabData',
                JSON.stringify(tabData)
            );
        };
    });
    return (
        <div>
            <TabBar tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
            <div className="page-container header-tab-spacer">
                <div className="container-fluid">
                    <Row className="mt-3">
                        <Col className="col-xl-3 col-lg-12 mb-3 mb-lg-0">
                            <SearchAdminProgramRequests
                                setTabData={setTabData}
                                setTabHeaders={setTabs}
                                tabHeaders={tabs}
                            />
                        </Col>
                        <Col className="col-xl-9 col-lg-12">
                            <TabsMaster
                                activeTab={activeTab}
                                tabData={tabData}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};
